<template>
  <div class="relative overflow-visible">
    <label
      v-if="hasLabel"
      class="text-default text-sm text-left block w-full pl-2 mb-2 mt-2 font-normal"
    >
      {{ $t('Project', 'Project') }}
    </label>
    <div
      class="rounded bg-gray-200 p-2 text-left flex justify-between items-center cursor-pointer"
      @click.stop="isOpen = !isOpen"
    >
      <div class="flex-grow flex justify-start flex-wrap">
        <tag
          v-for="p in selectedProjects"
          :key="p.id"
          :tag-name="p.name"
          class="mt-1"
          @remove="$emit('deselect', p);"
        />
      </div>
      <font-awesome-icon :icon="['fal', isOpen ? 'angle-up' : 'angle-down']" />
    </div>
    <div
      v-if="isOpen"
      v-click-outside="() => isOpen = false"
      class="w-full rounded bg-white p-2 shadow mt-1 z-10"
      style="top: 100%"
    >
      <div class="text-default text-left mb-2">
        Available projects
      </div>
      <div class="flex flex justify-start flex-wrap">
        <tag
          v-for="p in selectableProjects"
          :key="p.id"
          :tag-name="p.name"
          class="mt-1"
          :deletable="false"
          @click="$emit('select', p)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Tag from '@/global/ui/Tag'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons'
import vClickOutside from 'v-click-outside'

library.add(faAngleDown, faAngleUp)
export default {
  name: 'ProjectDropdown',
  components: { Tag, FontAwesomeIcon },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    allProjects: { type: Array, default: () => ([]) },
    selectedProjects: { type: Array, default: () => ([]) },
    hasLabel: { type: Boolean, default: true },
    defaultOpen: { type: Boolean, default: false }
  },
  data () {
    return { isOpen: false }
  },
  computed: {
    selectableProjects () {
      return this.allProjects.filter(p => !this.selectedProjects.find(sp => sp.id === p.id))
    }
  },
  watch: {
    isOpen (value) {
      if (!value) {
        this.$emit('closeDropdown')
      }
    }
  },
  mounted () {
    this.isOpen = this.defaultOpen
  }
}
</script>
